import { axiosInstance } from "@/lib/axiosInstance";

export interface WorkLogType {
  id: string;
  student_id: string;
  application_id: string;
  log_date: string;
  hours_worked: number;
  tasks_completed: string;
  challenges: string;
  status: string; // "pending", "reviewed", etc.
  reviewed_by_mentor?: string;
  created_at: string;
}

export interface WorkLogCreateType {
  application_id: string;
  log_date: string;
  hours_worked: number;
  tasks_completed: string;
  challenges?: string;
}

export interface WorkLogUpdateType {
  hours_worked: number;
  tasks_completed: string;
  challenges?: string;
}

export interface WorkLogParamsType {
  application_id?: string;
  page?: number;
  limit?: number;
}

export const fetchWorkLogs = async (params?: WorkLogParamsType) => {
  const res = await axiosInstance.get("v1/work-logs/", { params });
  let data = res.data;
  if (typeof data === "string") {
    try { data = JSON.parse(data); } catch (e) { }
  }
  return data;
};

export const getWorkLogById = async (logId: string) => {
  const res = await axiosInstance.get(`v1/work-logs/${logId}`);
  let data = res.data;
  if (typeof data === "string") {
    try { data = JSON.parse(data); } catch (e) { }
  }
  return data?.data || data;
};

export const createWorkLog = async (data: WorkLogCreateType) => {
  const res = await axiosInstance.post("v1/work-logs", data);
  return res.data;
};

export const updateWorkLog = async (logId: string, data: WorkLogUpdateType) => {
  const res = await axiosInstance.put(`v1/work-logs/${logId}`, data);
  return res.data;
};

export const deleteWorkLog = async (logId: string) => {
  const res = await axiosInstance.delete(`v1/work-logs/${logId}`);
  return res.data;
};
